module.exports = __webpack_public_path__ + "static/media/360 invite.bebdf0b3.svg";